import React, { useState, useEffect } from 'react';
import { widgetManager } from '../utils/widgetManager';
import TimeSeriesWidget from './TimeSeriesWidget';
import AddWidgetModal from './AddWidgetModal';
import './WidgetContainer.css';

function WidgetContainer({ authData, devices }) {
  const [widgetState, setWidgetState] = useState({ widgets: [], layout: [] });
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingWidget, setEditingWidget] = useState(null);

  useEffect(() => {
    const unsub = widgetManager.subscribe(setWidgetState);
    setWidgetState(widgetManager.getState());
    return unsub;
  }, []);

  const handleCreate = (title, config) => {
    const id = widgetManager.createWidget(title, config);
    setShowAddModal(false);
    widgetManager.loadWidgetData(id, authData.token);
  };

  const handleUpdate = (title, config) => {
    if (editingWidget) {
      widgetManager.updateWidget(editingWidget.id, { title, config });
      widgetManager.loadWidgetData(editingWidget.id, authData.token);
      setEditingWidget(null);
      setShowAddModal(false);
    }
  };

  const handleRefreshAll = () => {
    widgetState.widgets.forEach(w => widgetManager.loadWidgetData(w.id, authData.token));
  };

  return (
    <div className="widgets-view">
      <div className="widgets-header">
        <div>
          <h2>Telemetry Widgets</h2>
          <p className="subtitle">Build and manage multi-device timeline analytics panels</p>
        </div>
        <div className="header-controls">
          <button className="compare-btn primary" onClick={() => setShowAddModal(true)}>
            + Add Widget
          </button>
          <button className="compare-btn" onClick={handleRefreshAll}>
            Refresh All
          </button>
        </div>
      </div>

      <div className="widgets-grid-layout">
        {widgetState.widgets.length === 0 ? (
          <div className="no-data">
            <p>No telemetry widgets configured. Click "+ Add Widget" to build one.</p>
          </div>
        ) : (
          widgetState.widgets.map(widget => (
            <TimeSeriesWidget
              key={widget.id}
              widget={widget}
              token={authData.token}
              devices={devices}
              onEdit={(w) => { setEditingWidget(w); setShowAddModal(true); }}
              onDelete={(id) => widgetManager.deleteWidget(id)}
              onDuplicate={(id) => widgetManager.duplicateWidget(id)}
            />
          ))
        )}
      </div>

      {showAddModal && (
        <AddWidgetModal
          isEdit={!!editingWidget}
          existingWidget={editingWidget}
          devices={devices}
          authData={authData}
          onSave={editingWidget ? handleUpdate : handleCreate}
          onCancel={() => { setShowAddModal(false); setEditingWidget(null); }}
        />
      )}
    </div>
  );
}

export default WidgetContainer;
